<template>
  <ion-content class="ion-padding">
    <form @submit.prevent="closePopover(textNewMaterial)">
      <ion-label class="bold" position="floating"> Nom du matériel :</ion-label>
      <ion-input
        placeholder="Saisir ..."
        v-model="textNewMaterial"
        required="true"
      ></ion-input>
      <ion-button class="align-center" color="success" type="submit"
        >Valider</ion-button
      >
    </form>
  </ion-content>
</template>

<script>
import { IonContent, IonInput, IonButton, IonLabel } from '@ionic/vue';

export default {
  name: 'PopoverAddMaterial',
  components: {
    IonContent,
    IonInput,
    IonButton,
    IonLabel,
  },
  props: ['closePopover'],

  data() {
    return {
      textNewMaterial: '',
    };
  },
};
</script>
